import { ClockCircleFilled } from "@ant-design/icons";
import Paragraph from "antd/es/typography/Paragraph";
import Title from "antd/es/typography/Title";
import React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../../components/AvailabilityCalendar/AvailabilityCalendar.styles";

const Pending = ({ isTimedOut }) => {
  const { t } = useTranslation("result");
  return (
    <div style={{ paddingLeft: 10, paddingRight: 10 }}>
      <Title>
        <ClockCircleFilled style={{ color: "orange" }} />{" "}
        {t("paymentPendingTitle")}
      </Title>
      <Paragraph>
        {isTimedOut
          ? t("paymentStillPendingDescription")
          : t("paymentPendingDescription")}
      </Paragraph>
      {!isTimedOut && <Spinner />}
    </div>
  );
};

export default Pending;
